import { BooleanInput } from '@angular/cdk/coercion';
import {
  booleanAttribute,
  Component,
  input,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Card } from '../card/card.component';
import { GaugeChart } from '../gauge-chart/gauge-chart.component';

@Component({
  selector: 'procure-gauge-chart-widget',
  templateUrl: './gauge-chart-widget.component.html',
  styleUrl: './gauge-chart-widget.component.scss',
  imports: [GaugeChart, Card],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class GaugeChartWidget {
  readonly label = input.required<string>();
  readonly arcDelimiters = input<number[]>([]);
  readonly arcColors = input<string[]>([]);
  readonly needlePosition = input<number | null | undefined>(null);
  readonly height = input<number>(100);

  readonly transparent = input<boolean, BooleanInput>(false, {
    transform: booleanAttribute,
  });

  isNan(value: number | null | undefined): boolean {
    return Number.isNaN(value ?? NaN);
  }
}
